module.exports = __webpack_public_path__ + "img/nutrition-vegetable-fat.7738948.svg";